import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import Media from 'react-media'
import { mobile, desktop } from '../utils/media-query'
import Intro from './intro'
import GifCarousel from './gif-carousel'
import LandingPageGlobalStyles from '../../styles/landing-page'
import SDKValue from './sdk-value'
import EndBreaker from './end-breaker'
import Footer from './footer'
import DevProducts from './dev-products'
import Header from './header'
import KitCarousel from './kit-carousel'
import Shapes from './shapes'
import ShapesImage from '../../images/shapes/sdk.svg'
import { containerWidth, sectionMargin, sectionMobileMargin, containerMobilePadding } from '../constants'

const Centered = styled.div`
    section {
        margin-bottom: ${sectionMargin}px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 32px;
    }

    ${desktop.css`
        width: 100%;
        margin: 0 auto;
    `}

    ${mobile.css`
        width: 100%;

        section {
            margin-bottom: ${sectionMobileMargin}px;
            padding: 0 ${containerMobilePadding}px;

            &:first-child {
                margin-bottom: 0;
                padding: 0;
            }
        }
    `}

    &:first-child {
        section:first-child {
            margin-bottom: 0;
        }
    }

    &:last-child {
        section:last-child {
            margin-bottom: 0;
        }
    }
`

const SDKContainer = styled.div`
    position: relative;
    padding-top: 200px;
    margin-bottom: ${sectionMargin}px;
    width: ${containerWidth}px;

    ${mobile.css`
        width: 100%;
        padding-top: 0;

    `}
`

const ShapesMain = styled(Shapes)`
    top: 0;
    height: 105%;

    &:before {
        background-size: cover;
    }
`

const LandingPage = () => {
    const [mounted, setMounted] = useState(false)
    useEffect(() => setMounted(true), [])
    return (
        <>
            <LandingPageGlobalStyles />
            <Centered>
                <Header />
                <Intro />
            </Centered>
            <KitCarousel />
            <SDKContainer>
                {mounted && (
                    <Media query={mobile.query}>
                        {matches => (
                            <>
                                {!matches && <ShapesMain source={ShapesImage} />}
                                <GifCarousel />
                                <Centered>
                                    <SDKValue />
                                    {!matches && <DevProducts />}
                                </Centered>
                            </>
                        )}
                    </Media>
                )}
            </SDKContainer>
            <EndBreaker />
            <Centered>
                <Footer />
            </Centered>
        </>
    )
}

export default LandingPage
